export default {
    common: {
        language: '中国站',
        switchLanguage: '切换语言',
        documentationCenter: '文档中心',
        console: '控制台',
        signIn: '登录',
        register: '免费注册',
        Cart: '购物车',
        userInformation: '用户信息',
        unpaidOrders: '未付款订单',
        myTicket: '我的工单',
        exitAccount: '退出账户',
        selected: '精选',
    },

    index: {
        bannerButton: '查看详情',
        shop1: '畅销推荐 - 稳定高效，守护您的云端安全',
        shop2: '基于多年技术积累，提供高性能、高安全的云计算服务，保障企业数据与应用无忧上云。',
        viewAll: '查看全部',
        buyNow: '立即购买',
        noDataAvailable: '暂无数据',
        month: '月',
        nucleus: '核',
        memory: '内存',
        systemDisk: '系统盘',
        dataDisk: '数据盘',
        bandwidth: '带宽',
        defense: '防御',
        shopNow: '立即选购',
        goImmediately: '立即前往',
        viewAllProducts: '查看全部产品',
        shop3: '云计算就选',
        shop4: '云服务器 - 稳定高效，守护您的云端安全',
        shop5: '云计算新时代，',
        shop6: '以领先技术，为企业提供安全、高效、灵活的云服务。',
        cloudMarket: '一站式助力企业业务发展的云市场',
        cloudMarket2: '满足多样化的需求服务、打造为客户赋能的全过程生态体系',
        cloudMarket3: '千帆携手众多优秀伙伴，覆盖广泛行业与品类产品，全面满足企业上云及多样化的业务应用需求。通过打造丰富的场景化解决方案、提供海量优质产品与服务、成功助力大量客户，与伙伴共同构建繁荣的云上生态，持续推动客户实现产业革新。',
        cloudMarket4: '优秀伙伴，覆盖全行业全品类的产品，满足企业上云和各类业务的应用需求。打造',
        cloudMarket5: '的场景方案、输出',
        cloudMarket6: '的优质产品服务、服务',
        cloudMarket7: '客户，与伙伴共建云上生态，助力客户产业变革。',

        cloudMarket8: '精选优质服务商',
        cloudMarket9: '官方检测保质',
        cloudMarket10: '客服全程服务',
        cloudMarket11: '退款售后无忧',

        cloudMarket12: '商标注册',
        cloudMarket13: '服务器运维',
        cloudMarket14: '数据处理',
        cloudMarket15: '企业官网搭建',
        cloudMarket16: '企业资质办理',
        cloudMarket17: '400 电话办理',

        solution1: '行业解决方案',
        solution2: '为您的企业提供全方位的数字化转型服务',
        solution3: '企业级网站建设解决方案',
        solution3_3: '网站解决方案',
        solution4: '游戏云解决方案',
        solution5: '移动云解决方案',
        solution6: '金融云解决方案',
        solution7: '电商云解决方案',

        solution8: '​​企业级网站建设解决方案',
        solution9: '​​​我们提供一站式企业网站建设解决方案，包含响应式设计、SEO优化、高性能架构、安全防护、CMS后台管理及电商集成，采用前沿技术打造快速、安全、易用的现代化网站，助力企业提升品牌形象、优化用户体验并实现业务增长，同时提供持续的技术支持和数据分析服务，确保您的网站在竞争激烈的市场中保持领先优势。​',
        solution10: '客户满意度',
        solution11: '售后效率',
        solution12: '数据准确性',
        solution10_1: '优秀',
        solution11_2: '高效',
        solution12_3: '可靠',

        solution13: '​​我们提供专业的游戏行业解决方案，涵盖游戏官网开发、H5小游戏定制、游戏社区搭建、支付系统集成、数据分析平台及全球CDN加速，采用Unity',
        solution14: `​我们提供​​高性能、高安全、高体验​​的移动端全生命周期解决方案，覆盖​​原生App开发（iOS/Android）、跨平台应用（Flutter/React
                Native）、小程序（微信/支付宝/抖音）、PWA渐进式网页应用​​等多种技术形态，并整合​​AI智能推荐、AR增强现实、IoT物联网接入​​等创新技术，为企业打造极致流畅、安全可靠的移动产品体验。​​`,
        solution15: `​​我们提供​​安全合规、高性能、智能化​​的金融科技全栈解决方案，深度赋能银行、证券、保险、互联网金融等机构数字化转型。基于云计算、大数据、人工智能及区块链技术，构建覆盖​​数字银行、支付清算、智能风控、财富管理、保险科技、监管科技​​六大核心领域的完整产品矩阵，为金融机构提供从技术基础设施到业务创新的全方位支持。​​​`,
        solution16: `我们提供​​全渠道、智能化、高转化​​的电商全链路数字化解决方案，深度整合​​平台电商、社交电商、直播电商、跨境电商、新零售​​五大业态，构建从前端营销到后端供应链的完整商业生态。基于大数据与AI技术，打造集​​智能运营、精准营销、高效履约、数据驱动​​于一体的新一代电商基础设施，助力企业实现流量增长、转化提升与商业价值最大化。​​`,

        choice1: '为什么选择我们',
        choice2: '专业的服务团队，丰富的行业经验，为您提供最优质的服务',
        choice3: '安全可靠',
        choice4: '多重安全防护机制，保障数据安全',
        choice5: '快速响应',
        choice6: '7×24 小时技术支持，快速解决问题',
        choice7: '性能优异',
        choice8: '采用先进技术架构，确保高效运行',
        choice9: '专业服务',
        choice10: '经验丰富的技术团队，提供专业支持',

        choice11: '为何选择我们',
        choice12: '汇聚行业专业团队，深耕多年技术积累，致力于为您提供卓越可靠的一站式解决方案与服务',
        choice13: '全方位安全保障',
        choice14: '采用行业领先的多层级防护体系，严格遵循安全标准，确保业务数据、隐私信息与应用系统的全流程安全防护，为企业提供稳定可靠的安全环境',
        choice15: '数据加密',
        choice16: '访问控制',
        choice17: '实时监控',
        choice18: '极速响应支持',
        choice19: '提供7×24小时不间断技术服务支持，资深专家团队随时待命，快速响应各类技术问题与紧急需求，保障业务持续稳定运行无中断',
        choice20: '7x24在线',
        choice21: '分钟响应',
        choice22: '专业团队',
        choice23: '卓越性能表现',
        choice24: '基于先进的分布式技术架构与优化算法，提供高性能、高可用的运行环境，确保系统处理效率与响应速度，满足高并发业务场景需求',
        choice25: '高并发',
        choice26: '低延迟',
        choice27: '高可用',
        choice28: '专业技术服务',
        choice29: '拥有丰富行业经验的技术专家团队，提供从咨询规划、实施部署到运维优化的一站式专业服务，确保客户获得最佳技术解决方案与持续价值',
        choice30: '方案咨询',
        choice31: '实施部署',
        choice32: '运维支持',

        cooperativePartner1: '合作伙伴',
        cooperativePartner2: '与行业领先企业建立长期稳定的合作关系',
        cooperativePartner3: '聚优携手，共筑云生态未来',
        cooperativePartner4: '以卓越资源与专业服务为驱动，助力企业高效上云，携手开拓数字新境',

        build1: '安全合规、高速稳定的基础设施建设',
        build2: '遍布全球的基础设施节点为用户提供快速稳定、智能可靠的服务',
        build3: '全球基础设施',
        build4: '布局全球多个地理区域，提供高速稳定的云联接网络',
        build5: '了解详情',
        build6: '国家和地区',
        build7: '区域',
        build8: 'CDN节点',
        build9: '可用区',

        new1: '新闻动态',
        new2: '查看更多新闻',
        new3: '发布日期',
        new4: '新闻中心',
        new5: '公告中心',

        footer1: '计算',
        footer2: '公司介绍',
        footer3: '荣誉资质',
        footer4: '行业解决方案',
        footer5: '帮助与支持',
        footer6: '账户问题',
        footer7: '备案指南',
        footer8: '常见问题',
        footer9: '网站备案',
        footer10: '工单服务',
        footer11: '合作与生态',
        footer12: '代理合作',
        footer13: 'CPS推广',
        footer14: '官方公告',
        footer15: '联系我们',
        footer16: '产品中心',
        footer17: '管理与控制中心',
        footer18: '控制中心',
        footer19: '安全中心',
        footer20: '资源中心',
        footer21: '财务管理',
        footer22: '账户管理',
        footer23: '友情链接',
        footer24: '客服热线',

        footer25: '全天候售后服务',
        footer26: '7x24小时专业工程师品质服务',
        footer27: '极速服务应答',
        footer28: '秒级应答为业务保驾护航',
        footer29: '客户价值为先',
        footer30: '从服务价值到创造客户价值',
        footer31: '全方位安全保障',
        footer32: '打造一朵“透明可信”的云',

        footer33: '官方服务热线',

        loading1: '正',
        loading2: '在',
        loading3: '加',
        loading4: '载',
        loading5: '中',

        HzQuickjump1: '产品优势',
        HzQuickjump2: '产品功能',
        HzQuickjump3: '应用场景',
        HzQuickjump4: '客户之声',
        HzQuickjump5: '产品对比',
        HzQuickjump6: '快速入门',
    },

    agent: {
        bannerTitle: '代理商招募计划全面启动',
        bannerSubtitle: '海量资源 · 轻松部署 · 代理无忧 · 合作共赢',
        bannerButton: '立即加入',
        openProductAbility: '开放产品能力',
        product1Title: '云服务器',
        product1Desc: '高性能云计算服务器，提供稳定可靠的运行环境，支持弹性伸缩',
        product2Title: '云虚拟主机',
        product2Desc: '基于云计算的虚拟主机服务，为您提供安全稳定的网站托管方案',
        product3Title: '服务器托管',
        product3Desc: '专业的服务器托管服务，提供安全、稳定、高性能的托管环境',
        product4Title: '网站备案',
        product4Desc: '快速便捷的网站备案服务，专业团队全程指导，确保顺利通过',
        product5Title: '域名注册',
        product5Desc: '提供全球域名注册服务，支持多种后缀，价格优惠，注册便捷',
        product6Title: '裸金属服务器',
        product6Desc: '高性能物理服务器，提供独享资源，满足高性能计算需求',
        product7Title: 'CDN加速',
        product7Desc: '全球节点分发，智能加速，提供稳定快速的内容分发服务',
        product8Title: '更多服务',
        product8Desc: '探索更多云服务产品，为您的业务提供全方位解决方案',
        cooperationAdvantage: '合作优势',
        advantage1Title: '全渠道IDC资源接入',
        advantage1Desc: '支持多线BGP、电信、联通、移动等主流网络接入，提供多样化数据中心接口，实现业务弹性部署与资源高效协同。',
        advantage2Title: '高利润代理分成',
        advantage2Desc: '基于规模化云服务资源优势，提供具有竞争力的代理政策与阶梯式利润分成，帮助合作伙伴快速提升收益与市场份额。',
        advantage3Title: '零启动成本投入',
        advantage3Desc: '无需自建机房与硬件投入，依托我们成熟的云基础设施，支持按需付费与弹性扩容，助力业务快速上线与灵活扩展。',
        advantage4Title: '专业技术支持',
        advantage4Desc: '提供7×24小时运维支持、一对一技术咨询与售前售后全程服务，确保合作伙伴业务稳定运行与持续发展。',
        cooperationProcess: '合作流程',
        process1Title: '注册账号',
        process1Desc: '快速完成账号注册，开启智能合作之旅',
        process2Title: '服务授权',
        process2Desc: '完成服务授权，确保安全可靠的合作环境',
        process3Title: '购买系统',
        process3Desc: '选择适合的系统套餐，一键完成购买',
        process4Title: '系统配置',
        process4Desc: '专业团队协助完成系统个性化配置',
        process5Title: '开启合作',
        process5Desc: '正式启动合作，享受智能化服务体验',
        cooperationSupport: '合作支持',
        support1Title: '免费开通代理',
        support1EnTitle: 'Free Agent Access',
        support1Desc: '快速获取主机、云服务器、数据中心等全系列产品代理资格，享专属渠道权益',
        support2Title: '官方授权认证',
        support2EnTitle: 'Official Certification',
        support2Desc: '提供电子与纸质双认证，确保合作合规性与品牌授权效力',
        support3Title: '专享渠道价格',
        support3EnTitle: 'Channel Exclusive Pricing',
        support3Desc: '基于代理级别与业绩提供阶梯式优惠政策，增强您的市场报价竞争力',
        support4Title: '专属渠道经理',
        support4EnTitle: 'Dedicated Manager',
        support4Desc: '一对一全程跟进，提供售前咨询、方案定制与商务协作支持',
        support5Title: '专属产品培训',
        support5EnTitle: 'Product Training',
        support5Desc: '定期组织产品、技术与销售培训，助力团队快速掌握IDC与云服务专业知识',
        support6Title: '优势价格体系',
        support6EnTitle: 'Competitive Pricing',
        support6Desc: '依托规模化资源池提供优势渠道价格，支持您灵活制定市场策略',
        support7Title: '7×24售后支持',
        support7EnTitle: '24/7 Support',
        support7Desc: '提供全天候工单、在线与电话支持，快速响应并解决运维问题',
        support8Title: 'VIP技术支持',
        support8EnTitle: 'VIP Tech Support',
        support8Desc: '配备资深架构师与运维专家，为您的重要项目提供深度技术支持',
        contactUs: '联系我们',
        cooperationCondition: '合作条件',
        condition1Title: '公司资质',
        condition1Desc: '具有正规企业资质认证，拥有完善的管理体系和专业技术团队，确保合作稳定可靠。',
        condition2Title: '服务能力',
        condition2Desc: '配备专业技术支持团队，提供 7x24 小时响应服务，确保业务运营顺畅。',
        condition3Title: '业务能力',
        condition3Desc: '拥有丰富的客户资源和市场拓展经验，具备强大的业务执行和创新能力。',
        condition4Title: '合作意愿',
        condition4Desc: '秉持开放共赢理念，愿与优质伙伴建立长期稳定的战略合作关系。',
        faqTitle: '常见问题',
        faq1Question: '如何进行云服务代理合作？',
        faq1Step1: '注册主帐云平台账号，完成企业实名认证',
        faq1Step2: '提交代理申请，提供企业资质与业务计划',
        faq1Step3: '审核通过后，签订云服务代理合作协议',
        faq1Step4: '获得代理权限与管理后台，开始业务推广',
        faq2Question: '云服务代理资质要求？',
        faq2Requirement1: '企业营业执照（需在有效期内）',
        faq2Requirement2: '法人身份证及授权委托书',
        faq2Requirement3: 'IDC/ISP经营许可证或相关行业资质',
        faq2Requirement4: '具备云服务销售或技术团队',
        faq3Question: '可代理哪些云服务产品？',
        faq3Product1: '弹性云服务器 ECS',
        faq3Product2: '云数据库 RDS',
        faq3Product3: '云安全防护（WAF/DDOS）',
        faq3Product4: '云专线/CDN/负载均衡',
        faq3Product5: '对象存储/文件存储',
        faq3Product6: '混合云/私有云解决方案',
        faq3Product7: '容器服务与Kubernetes',
        faq3Product8: '机柜租赁/服务器托管',
        faq4Question: '代理合作优惠政策？',
        faq4Plan1Title: '标准代理',
        faq4Plan1Desc: '享受产品85折优惠 + 基础返点',
        faq4Plan2Title: '金牌代理',
        faq4Plan2Desc: '享受产品75折优惠 + 阶梯返点',
        faq4Plan3Title: '钻石代理',
        faq4Plan3Desc: '享受产品65折优惠 + 专属返点',
        faq4Plan4Title: '战略合作伙伴',
        faq4Plan4Desc: '定制优惠方案 + 专项支持',
        faq5Question: '技术支持与培训包含哪些？',
        faq5Support1: '7×24小时工单与电话技术支持',
        faq5Support2: '定期云产品技术培训与认证',
        faq5Support3: '售前方案支持与POC测试',
        faq5Support4: '专属技术经理与架构咨询',
        faq6Question: '结算与返点政策？',
        faq6Policy1Title: '结算周期',
        faq6Policy1Desc: '月度结算，T+15工作日付款',
        faq6Policy2Title: '返点方式',
        faq6Policy2Desc: '按季度业绩达成阶梯返点',
        faq6Policy3Title: '额外奖励',
        faq6Policy3Desc: '超额完成目标享受额外奖金',
        faq6Policy4Title: '市场支持',
        faq6Policy4Desc: '联合营销活动经费支持'
    },

    consult: {
        modalTitle: '方案咨询',
        formLabels: {
            contact: '联系人',
            company: '公司名称',
            phone: '手机号码',
            email: '邮箱',
            matter: '咨询产品'
        },
        formPlaceholders: {
            contact: '请输入联系人',
            company: '请输入公司名称',
            phone: '请输入手机号码',
            email: '请输入邮箱',
            matter: '请输入您要咨询的产品信息'
        },
        formRules: {
            contactRequired: '请输入联系人',
            phoneOrEmailRequired: '请填写手机或邮箱',
            phonePattern: '请输入正确的手机号码',
            emailType: '请输入正确的邮箱格式',
            matterRequired: '请输入咨询产品'
        },
        formError: {
            contactRequired: '请输入联系人',
            phoneOrEmailRequired: '手机号码和邮箱必须至少填写一个',
            phoneInvalid: '请输入正确的手机号码',
            emailInvalid: '请输入正确的邮箱格式',
            matterRequired: '请输入咨询产品',
            submitFailed: '提交失败，请稍后重试',
            networkError: '网络错误，请稍后重试'
        }
    },

    company: {
        aboutUs: '关于我们',
        bannerSlogan: '爱心、责任、诚信、双赢、合作、创新',
        quickJump: {
            companyProfile: '公司简介',
            corporateCulture: '企业文化',
            qualifications: '资质认证',
            honorRoad: '荣誉之路',
            feedback: '咨询反馈'
        },
        companyProfile: {
            title: '公司',
            title2: '简介',
        },
        corporateCulture: {
            title: '企业文化',
            subtitle: 'corporateCulture',
            mission: {
                title: '使命',
                desc: '让数据产生价值'
            },
            vision: {
                title: '愿景',
                desc: '让每一个组织和个体都看见并受益于数字化'
            },
            values: {
                title: '价值观',
                desc: '客户第一、团队合作、专业、担当'
            }
        },
        qualifications: {
            title: '资质认证'
        },
        honorRoad: {
            title: '荣誉之路',
            subtitle: 'Honor'
        },
        feedback: {
            title: '意见反馈信息',
            titlePlaceholder: '标题（必填项*）',
            contactPlaceholder: '联系方式',
            descriptionLabel: '意见描述：',
            descriptionPlaceholder: '请输入内容（必填项*）',
            submitButton: '立即提交',
            typeTitle: '您的意见类型选择',
            required: '(必选)'
        }
    },

    cps: {
        bannerTitle: '邀好友上云，赢35%返现奖励',
        bannerDesc: '个人用户可通过实名认证成为推广大使，在社交平台或个人站点发布专属推广链接获得关联客户，关联客户下单即可获得返现奖励。',
        joinNow: '立即加入',
        advantagesTitle: '推广优势',
        advantagesSubtitle: '我们提供全方位的推广解决方案，助力您的业务快速增长',
        commissionTitle: '丰厚佣金回报',
        commissionDesc: '我们为合作伙伴提供业内具有竞争力的佣金比例，您的每一次成功推广都将获得相应比例的返佣奖励，让您的推广价值得到实实在在的体现。',
        conversionTitle: '高转化产品支持',
        conversionDesc: '专注于IDC领域，提供从云服务器、物理服务器到高防、CDN等多样化的产品与解决方案。产品性能稳定、性价比突出，能够满足不同规模企业的需求，为您推广提供有力支撑，有效提高用户转化与成单效率。',
        coverageTitle: '广泛返佣覆盖',
        coverageDesc: '我们的返佣政策覆盖全面，无论是新用户的首次购买，还是老用户的续费升级，亦或是使用优惠活动的订单，只要通过您的专属推广链接完成，均可为您计算佣金，最大限度保障您的推广收益。',
        settlementTitle: '灵活快捷结算',
        settlementDesc: '我们致力于为合作伙伴提供顺畅的结算体验。支持多种主流的提现方式，无最低提现门槛限制，结算流程清晰高效，确保您的推广佣金能够及时、安全地到达您的账户。',
        joinTitle: '加入云推官',
        joinSubtitle: '客户通过推广者分享的推广链接成功可获现金奖励',
        step1Title: '注册登录会员',
        step1Time: '约2分钟',
        step1Desc: '快速注册成为云推官会员',
        step2Title: '升级为代销',
        step2Time: '约5分钟',
        step2Desc: '完成实名认证升级代销身份',
        step3Title: '推广获得分销商',
        step3Time: '约10分钟',
        step3Desc: '分享推广链接获取客户',
        step4Title: '享受双重返佣',
        step4Time: '约1-7个工作日',
        step4Desc: '成功推广即可获得奖励',
        methodsTitle: '推广方式',
        methodsSubtitle: '客户通过推广者分享的推广推荐成功可获现金奖励',
        method1Title: '精准广告推广',
        method1Desc: '通过智能算法精准定位目标用户，提供个性化广告投放服务。支持多平台广告位自主选择，实时数据监控，优化推广效果。配合完善的数据分析系统，让每一分投入都创造最大价值。',
        method1Feature1: '精准用户画像分析',
        method1Feature2: '多平台广告投放',
        method1Feature3: '实时效果监控',
        method2Title: '社群矩阵推广',
        method2Desc: '打造高质量社群生态，通过精细化运营建立忠实用户群体。提供专业的社群管理工具，帮助企业建立完整的社群运营体系，实现精准用户触达和转化。',
        method2Feature1: '社群运营体系搭建',
        method2Feature2: '活动策划执行',
        method2Feature3: '用户互动管理',
        method3Title: '内容营销推广',
        method3Desc: '专业的内容创作团队，为您打造高质量的品牌内容。覆盖文章、视频、图文等多种形式，通过优质内容建立品牌影响力，提升用户转化率。',
        method3Feature1: '专业内容创作',
        method3Feature2: '多平台内容分发',
        method3Feature3: '效果数据分析',
        startPromotion: '立即开始推广',
        distributorTitle: '代销优势',
        distributorSubtitle: '客户通过推广者分享的推广链接成功可获现金奖励',
        comparisonItem: '对比项',
        otherVendors: '其他云厂商',
        commissionAmount: '返佣额度',
        otherCommissionAmount: '15%左右（不含税，结算时需加除高额税费）',
        ourCommissionAmount: '纯18%收益',
        settlementCycle: '结算周期',
        otherSettlementCycle: '每月下旬结算上月佣金',
        ourSettlementCycle: '订单确认5天后即可提现',
        promotionScope: '推广范围',
        otherPromotionScope: '仅限个人用户推广',
        ourPromotionScope: '个人、企业、团队皆可参与',
        orderValidity: '订单有效性',
        otherOrderValidity: '优惠订单不计佣金',
        ourOrderValidity: '折扣订单同样计算返佣',
        technicalSupport: '技术支持',
        otherTechnicalSupport: '需排队等待客服响应',
        ourTechnicalSupport: '专属技术顾问1对1支持',
        commissionTiers: '佣金阶梯',
        otherCommissionTiers: '固定比例，无增长机制',
        ourCommissionTiers: '推广量越大，佣金比例越高',
        settlementMethods: '结算方式',
        otherSettlementMethods: '仅支持对公账户结算',
        ourSettlementMethods: '支持支付宝、微信、对公账户',
        promotionMaterials: '推广物料',
        otherPromotionMaterials: '基础素材，需自行设计',
        ourPromotionMaterials: '提供全套营销素材和文案',
        dataReports: '数据报表',
        otherDataReports: '每月1次数据同步',
        ourDataReports: '实时数据看板，随时查看',
        customerOwnership: '客户归属',
        otherCustomerOwnership: '客户流失后佣金终止',
        ourCustomerOwnership: '客户长期绑定，持续收益',
        rulesTitle: '代销规则',
        rulesSubtitle: '客户通过推广者分享的推广推荐成功可获现金奖励',
        commissionRulesTitle: '返利规则',
        firstSaleCommission: '首销佣金 = 有效销售收入 × 13%',
        renewalCommission: '续费佣金 = 有效续费收入 × 5%',
        qualificationTitle: '代销资格',
        qualificationDesc: '新老用户均可注册成为云服务推广代销商，享受全系产品推广权益',
        validSalesTitle: '有效销售收入',
        validSalesRule1: '指定推广产品为按年付费的云服务器、云虚拟主机',
        validSalesRule2: '被推广用户通过推广链接完成注册、购买并支付的第一笔订单，支付的现金部分属于有效销售收入',
        validSalesRule3: '被推广用户通过使用优惠券完成服务器和虚拟主机新购订单的支付，支付的现金部分属于有效销售收入',
        validSalesRule4: '因云服务器、虚拟主机的续费、升级产生的"有效销售收入"，具体返佣比例以产品返利规则为准',
        validSalesRule5: '因用户退货造成的退款将从有效销售收入中扣除',
        settlementTitle: '有效销售收入',
        settlementRule1: '推广者在订单创建后15天内由系统进行结算',
        settlementRule2: '结算规则及结算数据以系统统计数据为准',
        prohibitedTitle: '禁止条款',
        prohibitedDesc: '禁止利用恶意代码强制改变用户电脑设置；禁止强制捆绑等恶意方式，或其它使用用户反感或违反法律法规的非正当方式推广。'
    },

    doc: {
        bannerTitle: '文档中心',
        bannerDesc: '整合全系列产品的常见使用问题与开发文档，为您提供方便快捷的自助式指导服务，帮助您快速玩转云端。',
        searchPlaceholder: '请输入关键词搜索文档...',
        searchButton: '搜索',
        contentTitle: '文档内容'
    },

    ecommerce: {
        bannerTitle: '电商云解决方案',
        bannerDesc: '面对电商业务的指数级增长与复杂多变的商业环境，我们推出全栈式电商云解决方案，专为应对海量交易、突发流量与快速业务迭代而深度优化。我们不止提供基础设施，更构建从底层弹性资源到顶层智能应用的完整技术生态，助您在瞬息万变的市场中始终保持敏捷、稳定与竞争力。',
        freeConsultation: '免费咨询',
        advantagesTitle: '方案优势',
        advantagesSubtitle: '为您的企业提供全方位的网站解决方案',
        advantage1Title: '全球加速网络保障',
        advantage1Desc: '部署覆盖全球的高速网络节点，智能优化传输路径，确保玩家在全球任何地点都能获得低延迟、高稳定的流畅访问体验。',
        advantage2Title: '多重立体安全防护',
        advantage2Desc: '构筑从网络层、应用层到数据层的纵深安全体系，有效防御DDoS攻击、漏洞入侵与数据泄露，全面保障业务与用户信息安全。',
        advantage3Title: '智能弹性伸缩方案',
        advantage3Desc: '基于业务负载实时监控，实现计算、存储资源的自动化弹性伸缩，从容应对流量高峰与日常波动，优化资源利用与成本效率。',
        advantage4Title: '7×24小时专业护航',
        advantage4Desc: '提供全天候技术专家支持与运维保障，快速响应与解决各类技术故障，确保业务连续性，为您的稳定运营保驾护航。',
        architectureTitle: '解决方案架构',
        architectureSubtitle: '采用先进的技术架构，为您提供可靠的网站服务',
        architectureDescTitle: '架构说明',
        architectureDesc: '我们的电商解决方案采用分布式架构设计，通过多层级的服务节点部署，实现全渠道的商业运营。系统包含：',
        architectureFeature1: '全渠道商品管理系统',
        architectureFeature2: '智能订单处理中心',
        architectureFeature3: '支付安全与风控系统',
        architectureFeature4: '数据分析与运营平台',
        learnMore: '了解更多',
        painPointsTitle: '行业痛点',
        painPointsSubtitle: '对行业高速迭代与激烈竞争，传统的技术架构与运维模式已成为制约产品创新与增长的隐形天花板。',
        painPoint1Title: '业务敏捷性挑战',
        painPoint1Desc: '电商大促与热点活动频发，需实现分钟级计算资源部署与弹性扩缩，以支撑瞬时高并发订单与流量洪峰',
        painPoint2Title: '安全威胁升级',
        painPoint2Desc: 'DDoS攻击、恶意刷单、支付欺诈、数据爬取等安全威胁不断涌现，严重威胁电商业务与用户资产安全',
        painPoint3Title: '数据治理困境',
        painPoint3Desc: '订单、用户、商品、日志等多源海量数据的管理、集成、分析与应用复杂，数据驱动决策难度大、成本高',
        painPoint4Title: '系统恢复难题',
        painPoint4Desc: '需支持核心交易数据、订单与库存的无损、快速恢复，传统备份与回滚机制难以满足电商高可用性要求'
    },

    finance: {
        bannerTitle: '金融云解决方案',
        bannerDesc: '面对金融行业数字化转型与严格监管的双重挑战，我们提供安全合规、智能敏捷的金融云解决方案，为银行、证券、保险、互联网金融等机构构建坚实可靠的数字底座，赋能业务创新、提升运营效率、实现价值最大化，在合规框架下加速金融服务的智能化升级。',
        freeConsultation: '免费咨询',
        advantagesTitle: '方案优势',
        advantagesSubtitle: '为您的企业提供全方位的网站解决方案',
        advantage1Title: '金融级性能保障',
        advantage1Desc: '提供高可用、低延迟的金融级云架构，支持高频交易毫秒级响应，满足金融业务对极致性能与稳定性的严苛要求',
        advantage2Title: '等保合规防护',
        advantage2Desc: '构建满足等保三级、金融监管要求的安全体系，实现数据加密、访问控制、审计追溯的全方位安全防护',
        advantage3Title: '智能弹性扩展',
        advantage3Desc: '基于业务负载智能弹性伸缩，支持交易峰值期间资源自动扩容，保障系统平稳运行，优化资源成本',
        advantage4Title: '专属技术护航',
        advantage4Desc: '提供7×24小时金融专属技术支持团队，具备丰富金融行业经验，快速响应并解决业务系统各类技术问题',
        architectureTitle: '解决方案架构',
        architectureSubtitle: '采用先进的技术架构，为您提供可靠的网站服务',
        architectureDescTitle: '架构说明',
        architectureDesc: '我们的金融解决方案采用分布式架构设计，通过多层级的服务节点部署，实现全渠道的金融业务运营。系统包含：',
        architectureFeature1: '全渠道交易管理系统',
        architectureFeature2: '智能风控处理中心',
        architectureFeature3: '支付安全与监控系统',
        architectureFeature4: '数据分析与运营平台',
        learnMore: '了解更多',
        painPointsTitle: '行业痛点',
        painPointsSubtitle: '对行业高速迭代与激烈竞争，传统的技术架构与运维模式已成为制约产品创新与增长的隐形天花板。',
        painPoint1Title: '业务敏捷性挑战',
        painPoint1Desc: '金融市场快速变化，业务创新需求迫切，但传统核心系统迭代缓慢，难以支持敏捷开发与分钟级资源弹性扩展',
        painPoint2Title: '合规与安全压力',
        painPoint2Desc: '金融行业监管要求严格，面临等保合规、数据安全、交易反欺诈等多重安全挑战，传统架构难以满足全栈防护需求',
        painPoint3Title: '数据治理困境',
        painPoint3Desc: '多源异构金融数据的采集、整合、分析与价值挖掘面临技术瓶颈，数据资产化进程缓慢，智能决策能力不足',
        painPoint4Title: '灾备与连续性难题',
        painPoint4Desc: '需满足监管对业务连续性的高要求，传统灾备方案成本高昂、恢复时间长，难以实现业务分钟级无缝切换与恢复'
    },

    game: {
        bannerTitle: '游戏云解决方案',
        bannerDesc: '我们不仅提供工具，更提供一套强大的综合解决方案，旨在赋能游戏开发者，攻克从核心技术优化到玩家沉浸感打造的全方位挑战。我们的目标是让您能更专注于创意本身，而将性能、稳定与体验的难题交给我们解决。',
        freeConsultation: '免费咨询',
        advantagesTitle: '方案优势',
        advantagesSubtitle: '为您的企业提供全方位的网站解决方案',
        advantage1Title: '游戏更新智能分发',
        advantage1Desc: '依托全球智能CDN网络与P2P传输技术，实现游戏补丁、DLC及资源文件的极速、精准分发。支持差异更新与智能预加载，大幅缩减玩家等待时间，将更新失败率降至最低，保障全球玩家同步体验最新内容。',
        advantage2Title: '弹性卡密实习方案',
        advantage2Desc: '提供一站式、高可用的虚拟商品与卡密管理解决方案。支持批量生成、加密存储、多渠道分发与实时核销，无缝集成至您的商城与支付系统。具备高级风控与防刷机制，全面保障每一笔交易的安全与准确。',
        advantage3Title: '海量级日志存储',
        advantage3Desc: '构建PB级别的实时日志大数据平台，毫秒级采集游戏内行为、性能、异常及业务日志。提供强大的可视化分析、实时监控与智能告警功能，助您精准把握玩家动态、定位性能瓶颈、驱动产品优化与运营决策。',
        advantage4Title: '跨比专线动力引擎',
        advantage4Desc: '基于覆盖全球的优质骨干网络与智能路由技术，为游戏提供专属高速通道。有效降低跨国、跨运营商访问的延迟与丢包，显著提升联机对战、实时语音的稳定性与流畅性，为全球同服竞技提供坚实网络基础。',
        architectureTitle: '解决方案架构',
        architectureSubtitle: '采用先进的技术架构，为您提供可靠的网站服务',
        architectureDescTitle: '架构说明',
        architectureDesc: '游戏云解决方案采用最新的微服务架构，实现高可用、高性能、高扩展的游戏服务平台。支持容器化部署，自动扩缩容，智能负载均衡等特性。',
        architectureFeature1: '多区域部署，就近接入',
        architectureFeature2: '自动扩缩容，成本优化',
        architectureFeature3: '实时监控，故障预警',
        architectureFeature4: '安全防护，数据加密',
        learnMore: '了解更多',
        painPointsTitle: '行业痛点',
        painPointsSubtitle: '对行业高速迭代与激烈竞争，传统的技术架构与运维模式已成为制约产品创新与增长的隐形天花板。',
        painPoint1Title: '业务敏捷性挑战',
        painPoint1Desc: '游戏运营需求快速变化，需实现分钟级服务器部署，并支持有状态服务的弹性扩缩容',
        painPoint2Title: '安全威胁升级',
        painPoint2Desc: 'DDoS攻击、外挂破解等网络攻击日益频繁，新型安全漏洞不断涌现，严重威胁游戏业务稳定',
        painPoint3Title: '运维数据困境',
        painPoint3Desc: '海量游戏日志的采集、存储、检索、分析及监控告警流程复杂，运维管理成本高昂',
        painPoint4Title: '数据恢复难题',
        painPoint4Desc: '需支持两周内任意时间点的数据与日志无损回档，传统备份方案难以满足快速精准恢复需求'
    },

    service: {
        bannerTitle: '百分服务，助您上云无忧',
        bannerDesc: '匠心打造完整的VIP会员服务体系，为国内国际用户提供多种服务支持和服务保障让用户尊享售后服务，让云端部署更轻松、更高效',
        quickJump: {
            basicService: '基础服务',
            filing: '0 元免费备案',
            compensation: '1倍故障赔偿',
            refund: '1天无理由退款'
        },
        basicServiceTitle: '基础服务',
        basicServiceSubtitle: '7 × 24 小时的多种服务渠道，助您轻松上云',
        support24x7Title: '7X24小时全天候服务支持',
        support24x7Desc: '专业的售后工程师团队为您提供7 * 24 * 365全方位技术服务，确保您的业务运行无忧',
        preSales: '售前服务',
        preSalesDesc: '我们的专业顾问团队将深入了解您的需求，提供定制化的产品咨询和解决方案建议，助您做出最佳选择。',
        preSalesConsult: '售前咨询',
        duringSales: '售中服务',
        duringSalesDesc: '为您配备专业的项目实施团队，一对一提供全程技术指导，确保系统快速、稳定上线运行。',
        duringSalesConsult: '售中咨询',
        afterSales: '售后服务',
        afterSalesDesc: '我们的技术支持团队全天候待命，为您提供及时、专业的问题解决和系统优化服务，保障您的业务持续高效运转。',
        afterSalesConsult: '售后咨询',
        technicalTicket: '技术工单',
        technicalTicketDesc: '7 × 24 小时工单支持，在线提供服务',
        submitTicket: '提交工单',
        vipServiceTitle: 'VIP多对1服务',
        vipServiceDesc: '为您提供更专业、更高效的一站式解决方案',
        wechatGroup: '微信讨论组',
        wechatGroupDesc: '加入专属VIP微信群，与专家直接交流，获取实时支持和建议',
        qqContact: 'QQ联系',
        qqContactDesc: '通过QQ随时与我们的客服团队取得联系，快速解决您的问题',
        consultationHotline: '咨询热线',
        consultationHotlineDesc: '拨打专线电话，我们的专业顾问将为您提供即时的语音咨询服务',
        filingTitle: '0 元免费备案',
        filingSubtitle: '为用户提供免费备案服务，1V1 备案处理机制，最快 1 个工作日取得备案号',
        filingStep1: '登录会员中心',
        filingStep2: '录入资料提交',
        filingStep3: '提交管局审核',
        filingStep4: '备案成功',
        filingButton: '我要备案',
        faqTitle: '备案常见问题',
        faq1Question: '备案需要多长时间？',
        faq1Answer: '备案资料提交成功后，我司会在 1-2 个工作日内初审并提交至管局，审核时长要看各个管局的审核效率，管局的审核方回复是在 20 个工作日内完成。大多数地区管局实际审核时长在 1-2 周。需按通过后台公众短信或邮件的形式通知您。由于是后台审核是管局，我们只能及时查看权限范围内的进度，所以请耐心等待管局审核结果，并无其他加快备案的方法。',
        faq2Question: '备案期间网站要关站吗？',
        faq2Answer: '①、新增备案或者新增网站备案：没有备案的域名是不允许进行访问的。需要确认您的域名是打不开的，再做备案操作；（新增备案的域名在管局审核期间需要关闭网站，取得备案号后才可以开通网站。）②、接入备案：网站需要正常打开；如果您的备案管局审核失败，请您尽快根据管局说的原因进行修改后重新提交。',
        faq3Question: '如何添加白名单？',
        faq3Answer: '域名已经有备案记录，可以添加白名单直接使用，无需等待审核，提交即可解析使用①、登录官网会员中心，输入账户及密码进行登录②、登录官网会员中心，左边框栏点击备案管理，选择白名单，在页面中选择提交白名单③、输入正确的备案过的"域名"及"网站备案/许可证号"即可提交，提交即过白名单，可以直接使用，无需等待审核，④、如果提交白名单的域名比较多，可以操作选择"白名单批量添加"按钮进行批量提交白名单加入的白名单会统一在已加入白名单列表，因无备案记录等原因退回的，统一在未加入白名单列表（可以重新申请加入白名单）',
        faq4Question: '幕布照片的要求及部位说明',
        faq4Answer: '您好，目前备案是支持邮寄幕布的。备案幕布照片要求：站在幕布正中间拍照，只拍上半身即可。整个画面背景必须都是幕布，显示效果幕布字迹清晰。',
        compensationTitle: '1倍故障赔偿',
        compensationSubtitle: '承诺由于网络故障导致产品无法正常使用，我们将提供1倍的故障时间赔偿让您使用舒心备案处理机制，最快 1 个工作日取得备案号',
        compensationStep1: '联系客服/提交工单',
        compensationStep2: '技术排查定位问题',
        compensationStep3: '快速解决故障',
        compensationStep4: '核实赔偿范围',
        compensationStep5: '赔偿1倍故障时间',
        compensationTypes: '赔偿类型',
        compensationType1: '故障赔偿',
        compensationType1Desc: '网络平台原因导致的云服务器、云虚拟主机、服务器托管等不可访问，不可正常使用',
        compensationType2: '非故障类不可补偿',
        compensationType2Desc: '用户因操作或被攻击导致的云产品不能访问、IP被封停的情况，不可补偿',
        compensationType3: '运营商故障不可补偿',
        compensationType3Desc: '由于运营商故障导致的丢包和延时，不可抗力，意外事件导致的损失不在赔偿范围内',
        refundTitle: '1天无理由退款',
        refundSubtitle: '承诺用户购买云服务器1天内无条件退款，致力为您打造更优良的服务器体验环境。购买网络服务器，我们承诺1天无理由全额退款',
        refundStep1: '提交退款申请',
        refundStep1Desc: '通过我们的客户服务平台提交您的退款申请。',
        refundStep2: '审核确定',
        refundStep2Desc: '我们的客服团队将迅速审核您的申请。',
        refundStep3: '退款至账余额',
        refundStep3Desc: '审核通过后，退款金额将迅速返还到您的账户余额。',
        refundStep4: '重新购买',
        refundStep4Desc: '您可以选择使用账户余额重新购买或申请提现。',
        refundFaqTitle: '退款常见问题',
        refundFaq1Question: '1天无理由退款条件',
        refundFaq1Answer: '①、新购1天内可申请无理由退款；②、每个用户每月云服务器限最多退款1次，每月最多累积可退1台；每个用户云虚拟主机限每月最多退款1次，每月最多累积可退1台；③、未签订合同及申请发票；④、部分活动产品不支持1天无理由退款（详情请见活动规则）。',
        refundFaq2Question: '退款流程',
        refundFaq2Answer: '用户中心提交退款申请 > 系统审核通过 > 款项退至您的聚变网络账户，您可以直接前往用户中心查看。',
        refundFaq3Question: '续费、升级订单可以申请退款吗？',
        refundFaq3Answer: '您好，续费及升级订单为子订单，不可申请退款；如主购买订单符合1天内无理由退款规则，可申请一并退款；'
    },

    mobile: {
        bannerTitle: '移动云解决方案',
        bannerDesc: '面对移动业务的高速发展和数字化转型需求，我们提供端到端的移动云整体解决方案。通过创新的资源调度、智能的安全管控和可靠的运维保障，我们不仅致力于实现计算、存储、网络资源的最优配置与最高效利用，更构建了全链路的数据安全和业务连续性保障体系，确保您的移动应用、移动办公、物联网等业务在安全、可靠、高效的云环境中稳定运行和持续创新。',
        freeConsultation: '免费咨询',
        advantagesTitle: '方案优势',
        advantagesSubtitle: '为您的企业提供全方位的网站解决方案',
        advantage1Title: '移动优先性能架构',
        advantage1Desc: '专为移动场景优化的云架构，支持海量移动端并发连接，提供稳定可靠的网络通信和数据传输保障，确保移动应用访问体验流畅无延迟',
        advantage2Title: '全链路安全防护',
        advantage2Desc: '构建涵盖移动终端、网络传输、云端服务的安全防护体系，提供应用加固、通信加密、数据脱敏等多重防护措施，保障移动业务与用户数据安全',
        advantage3Title: '智能边缘计算',
        advantage3Desc: '结合边缘节点与中心云的协同能力，实现计算资源向用户侧延伸，有效降低端到端延迟，提升移动应用响应速度与交互体验',
        advantage4Title: '移动化专属支持',
        advantage4Desc: '配备熟悉移动互联网生态的专业技术团队，7×24小时提供架构优化、性能调优、故障诊断等全方位技术支持，保障移动业务稳定运行',
        architectureTitle: '解决方案架构',
        architectureSubtitle: '采用先进的技术架构，为您提供可靠的网站服务',
        architectureDescTitle: '架构说明',
        architectureDesc: '我们的移动云解决方案采用分布式架构设计，通过多层级的服务节点部署，实现全球化的业务覆盖。系统包含：',
        architectureFeature1: '边缘节点智能调度系统',
        architectureFeature2: '全球化负载均衡机制',
        architectureFeature3: '实时监控和故障自愈系统',
        architectureFeature4: '智能化运维管理平台',
        learnMore: '了解更多',
        painPointsTitle: '行业痛点',
        painPointsSubtitle: '对行业高速迭代与激烈竞争，传统的技术架构与运维模式已成为制约产品创新与增长的隐形天花板。',
        painPoint1Title: '资源调度效率挑战',
        painPoint1Desc: '移动应用业务波动剧烈，资源需求弹性大，传统静态资源配置模式难以应对用户访问峰值，导致资源浪费或性能瓶颈',
        painPoint2Title: '端到端安全风险',
        painPoint2Desc: '移动环境复杂多变，面临应用安全、数据安全、通信安全等多重威胁，传统安全方案难以覆盖端到端全链路的安全防护需求',
        painPoint3Title: '跨网络体验难题',
        painPoint3Desc: '用户分散在不同网络环境，网络延迟和稳定性差异大，移动应用难以保证所有用户一致的高质量访问体验和交互效果',
        painPoint4Title: '运维管理复杂度高',
        painPoint4Desc: '移动端、云端、网络等多层架构运维复杂，问题定位困难，传统运维工具难以实现端到端全链路的统一管理和智能运维'
    },

    news: {
        bannerTitleNews: '新闻中心',
        bannerTitleAnnouncement: '公告中心',
        bannerDesc: '我们将实时发布计算服务动态与最新资讯，助力您更好地了解和使用计算产品与服务。',
        loading: '正在加载...',
        newsCenter: '新闻中心',
        announcementCenter: '公告中心',
        newsDetails: '新闻详情',
        totalData: '共',
        records: '条数据',
        newsAnnouncement: '新闻公告'
    },

    newsDetail: {
        home: '首页',
        announcementHome: '公告主页',
        keywords: '关键词：',
        noKeywords: '未添加关键词',
        source: '来源：',
        publishTime: '发布时间：',
        shareLink: '分享链接',
        shareLinkAlt: '分享链接',
        shareWeChat: '分享到微信',
        shareWeChatAlt: '分享到微信',
        shareQQ: '分享到QQ',
        shareQQAlt: '分享到QQ',
        previous: '上一篇：',
        next: '下一篇：',
        newsAnnouncement: '新闻公告'
    },

    product: {
        console: '控制台',
        suitableRegion: '适用区域',
        quickJump: {
            advantages: '产品优势',
            features: '产品功能',
            applicationScenarios: '应用场景',
            customerVoice: '客户之声',
            productComparison: '产品对比',
            quickStart: '快速入门'
        },
        advantages: '产品优势',
        features: '产品功能',
        applicationScenarios: '应用场景',
        customerVoice: '客户之声',
        productComparison: '产品对比',
        comparisonSubtitle: '客户通过推广者分享的推广链接成功可获现金奖励',
        comparisonItem: '对比项',
        otherVendors: '其他云厂商',
        quickStart: '快速入门'
    },

    website: {
        bannerTitle: '网站解决方案',
        bannerDesc: '采用WAF防火墙、DDoS防护、入侵检测系统(IDS)及定期渗透测试，构建企业级安全屏障',
        freeConsultation: '免费咨询',
        advantagesTitle: '方案优势',
        advantagesSubtitle: '为您的企业提供全方位的网站解决方案',
        advantage1Title: '企业级高性能架构',
        advantage1Desc: '基于微服务与容器化技术构建的可扩展架构，支持高并发访问与智能负载均衡，确保网站在业务高峰期的稳定运行与毫秒级响应',
        advantage2Title: '全方位安全防护体系',
        advantage2Desc: '多层安全防御架构，涵盖WAF防火墙、DDoS防护、入侵检测、数据加密与合规审计，为企业网站提供银行级安全保障与合规支持',
        advantage3Title: '智能运维与全球加速',
        advantage3Desc: '7×24小时智能监控预警系统结合全球CDN网络，实现故障自愈与分钟级响应，为全球用户提供一致的高质量访问体验',
        advantage4Title: '全生命周期定制服务',
        advantage4Desc: '从咨询规划、定制开发到持续运维的全流程服务，支持与现有业务系统无缝集成，助力企业构建数字化转型的核心数字门户',
        architectureTitle: '解决方案架构',
        architectureSubtitle: '采用先进的技术架构，为您提供可靠的网站服务',
        architectureDescTitle: '架构说明',
        architectureDesc: '我们的解决方案采用多层架构设计，通过合理的系统组件配置，实现高可用、高性能的网站服务：',
        architectureFeature1: '负载均衡层确保请求合理分配，提高系统整体性能',
        architectureFeature2: '应用服务层采用容器化部署，便于扩展和维护',
        architectureFeature3: '数据层使用主从架构，确保数据安全和服务可用性',
        architectureFeature4: '监控系统实时掌握各组件状态，快速响应异常情况',
        learnMore: '了解更多',
        painPointsTitle: '行业痛点',
        painPointsSubtitle: '对行业高速迭代与激烈竞争，传统的技术架构与运维模式已成为制约产品创新与增长的隐形天花板。',
        painPoint1Title: '资源调度效率挑战',
        painPoint1Desc: '移动应用业务波动剧烈，资源需求弹性大，传统静态资源配置模式难以应对用户访问峰值，导致资源浪费或性能瓶颈',
        painPoint2Title: '端到端安全风险',
        painPoint2Desc: '移动环境复杂多变，面临应用安全、数据安全、通信安全等多重威胁，传统安全方案难以覆盖端到端全链路的安全防护需求',
        painPoint3Title: '跨网络体验难题',
        painPoint3Desc: '用户分散在不同网络环境，网络延迟和稳定性差异大，移动应用难以保证所有用户一致的高质量访问体验和交互效果',
        painPoint4Title: '运维管理复杂度高',
        painPoint4Desc: '移动端、云端、网络等多层架构运维复杂，问题定位困难，传统运维工具难以实现端到端全链路的统一管理和智能运维'
    },
}